import { AppBar, IconButton, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import palette from 'app/theme/palette';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
	root: {
		boxShadow: 'none',
		backgroundColor: theme.palette.blue.main,
		color: palette.primary.dark,
	},
	flexGrow: {
		flexGrow: 1,
	},
}));

const TopBar = ({ onOpenNavBarMobile }) => {
	const classes = useStyles();

	return (
		<AppBar className={classes.root}>
			<Toolbar>
				<RouterLink to="/">
					<img alt="Logo" src="./images/logo.svg" />
				</RouterLink>
				<div className={classes.flexGrow} />
				<IconButton onClick={onOpenNavBarMobile}>
					<MenuIcon />
				</IconButton>
			</Toolbar>
		</AppBar>
	);
};

TopBar.propTypes = {
	onOpenNavBarMobile: PropTypes.func.isRequired,
};

export default TopBar;
